import { Bar }  from 'vue-chartjs'
import moment   from 'moment'

export default {
  
  extends: Bar,

  props : {
    chartData : {
      type : Array,
      required : true
    }
  },

  // data() {
  //   return {
  //     labels : null,
  //     values : null
  //   }
  // },

  // created() {
  //   this.labels = []
  //   this.values = []
  //   for(let i=0; i < this.chartData.length; i++) {
  //     this.labels.push(this.chartData[i].day)
  //     this.values.push(this.chartData[i].value)
  //   }
  // },

  watch: {
    chartData: function (newData, oldData) {
      this.draw()
    }
  },

  computed : {
    labels() {
      let labels = []
      for(let i=0; i < this.chartData.length; i++) {
        labels.push(moment(this.chartData[i].day, "YYYY-MM-DD").format("D MMM"))
      }

      return labels 
    },

    values() {
      let values = []
      for(let i=0; i < this.chartData.length; i++) {
        values.push(this.chartData[i].value)
      }

      return values 
    },
  },

  mounted () {
    this.draw()
  },

  methods : {
    draw() {
      this.renderChart({
        labels  : this.labels,
        datasets: [{
          // label          : 'Data One',
          backgroundColor: '#0062BA',
          data           : this.values
        }]
        // datasets: [{
        //     label: 'Data One',
        //     backgroundColor: '#FC2525',
        //     data: [40, 39, 10, 40, 39, 80, 40]
        //   },{
        //     label: 'Data Two',
        //     backgroundColor: '#05CBE1',
        //     data: [60, 55, 32, 10, 2, 12, 53]
        //   }
        // ]
      }, {
        responsive         : true, 
        maintainAspectRatio: false,
        legend             : {
          display: false
        },
      })
    }
  }
}